import React, { useState } from 'react';
import './ADLTooltip.css';

function ADLTooltip() {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      top: rect.top - 10,
      left: rect.left + rect.width / 2
    });
    setShowTooltip(true);
  };

  return (
    <div 
      className="adl-tooltip-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={(e) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltipPosition({
          top: rect.top - 10,
          left: rect.left + rect.width / 2
        });
        setShowTooltip(!showTooltip);
      }}
    >
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 16 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="info-icon"
      >
        <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        <path d="M8 5V8M8 11H8.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      {showTooltip && (
        <div 
          className="adl-tooltip" 
          style={{ 
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
            transform: 'translateX(-50%) translateY(-100%)'
          }}
        >
          <div className="tooltip-header">Auto-Deleveraging (ADL) Risk</div>
          <div className="tooltip-content">
            <p><strong>ADL Scale: 1/5 to 5/5</strong> (where 1/5 is safest, 5/5 is most dangerous)</p>
            <p>ADL quantile indicates your position's risk of being auto-deleveraged when other traders' accounts become underwater.</p>
            
            <div className="adl-levels">
              <div className="adl-level">
                <span className="adl-badge adl-1">1</span>
                <span>Lowest risk - Safest (least likely to be ADL'd)</span>
              </div>
              <div className="adl-level">
                <span className="adl-badge adl-2">2</span>
                <span>Low risk</span>
              </div>
              <div className="adl-level">
                <span className="adl-badge adl-3">3</span>
                <span>Medium risk</span>
              </div>
              <div className="adl-level">
                <span className="adl-badge adl-4">4</span>
                <span>High risk</span>
              </div>
              <div className="adl-level">
                <span className="adl-badge adl-5">5</span>
                <span>Highest risk - Most dangerous (most likely to be ADL'd)</span>
              </div>
            </div>
            
            <div className="tooltip-exchange-info">
              <p><strong>Binance:</strong> ADL quantile (1-5) based on position risk metrics.</p>
              <p><strong>Hyperliquid:</strong> Traders ranked by <code>(mark_price / entry_price) × (notional / account_value)</code>. Lower values = safer.</p>
            </div>
            
            <p className="tooltip-note">⚠️ ADL ensures platform solvency. If another trader's account goes negative, profitable positions on the opposite side may be auto-closed.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ADLTooltip;
